import { dashboardT, type DashboardMessageKey } from '../../../../../lib/messages';

export enum IntegrationColumnId {
  Name = 'name',
  Status = 'status',
  Placements = 'placements',
  IntegrationType = 'integrationType',
  Srpm = 'srpm',
  BidRatio = 'bidRatio',
  Revenue7d = 'revenue7d',
  Ecpm7d = 'ecpm7d',
  Qps = 'qps',
  SellerDomain = 'sellerDomain',
  Duplication = 'duplication',
  Note = 'note',
  Actions = 'actions',
}

export const INTEGRATION_COLUMN_IDS = Object.values(IntegrationColumnId);
export const INTEGRATION_LOCKED_COLUMN_IDS = [
  IntegrationColumnId.Name,
  IntegrationColumnId.Actions,
] as const;
export const INTEGRATION_DEFAULT_HIDDEN_COLUMN_IDS = [
  IntegrationColumnId.SellerDomain,
  IntegrationColumnId.Duplication,
  IntegrationColumnId.Note,
] as const;

const integrationColumnLabelKeys: Record<IntegrationColumnId, DashboardMessageKey> = {
  [IntegrationColumnId.Name]: 'integrations.name',
  [IntegrationColumnId.Status]: 'integrations.status',
  [IntegrationColumnId.Placements]: 'integrations.placements',
  [IntegrationColumnId.IntegrationType]: 'integrations.integrationType',
  [IntegrationColumnId.Srpm]: 'integrations.srpm',
  [IntegrationColumnId.BidRatio]: 'integrations.bidRatio',
  [IntegrationColumnId.Revenue7d]: 'integrations.revenue7d',
  [IntegrationColumnId.Ecpm7d]: 'integrations.ecpm7d',
  [IntegrationColumnId.Qps]: 'integrations.qpsCap',
  [IntegrationColumnId.SellerDomain]: 'integrations.sellerDomain',
  [IntegrationColumnId.Duplication]: 'integrations.duplication',
  [IntegrationColumnId.Note]: 'integrations.note',
  [IntegrationColumnId.Actions]: 'integrations.actions',
};

export function integrationColumnLabel(id: IntegrationColumnId): string {
  return dashboardT(integrationColumnLabelKeys[id]);
}
